import { matchPath } from "react-router";
import { usePublicSurveyQuery } from "../../../api/surveys/usePublicSurveyQuery";
import { PUBLIC_ROUTES } from "../../../consts/routes";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { uiNotification } from "../../../services/UINotificationService";
import { extractApiError } from "../../../utilities/api";

export function useSurvey() {
  var { tSurvey: t } = useAppTranslation.Survey();

  var { params } = matchPath(window.location.pathname, {
    path: PUBLIC_ROUTES.survey(),
    exact: true,
  });

  var { data, isError } = usePublicSurveyQuery(
    { hash: params.hash, accountId: Number(params.accountId) },
    {
      onError: (res) => {
        const message = extractApiError(res);
        uiNotification.error(t([`error.${message}`, "error.fetch"]));
      },
    },
  );

  return {
    data,
    isLoading: !isError && !data,
    isError,
    hash: params.hash,
  };
}
